import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { EntityOptionResponse } from '@/types/entityOption';
import type { SupplierRequest, SupplierResponse } from '@/types/supplier';

export const suppliersApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<SupplierResponse>>>('/v1/suppliers', { params })),

  listOptions: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<EntityOptionResponse>>>('/v1/suppliers/options', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<SupplierResponse>>(`/v1/suppliers/${id}`)),

  create: (body: SupplierRequest) =>
    unwrap(api.post<ApiResponse<SupplierResponse>>('/v1/suppliers', body)),

  update: (id: number, body: SupplierRequest) =>
    unwrap(api.put<ApiResponse<SupplierResponse>>(`/v1/suppliers/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/suppliers/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<SupplierResponse>>(`/v1/suppliers/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
